import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../../services/services.service';
import { environment } from '../../../environments/environment';
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';

@Component({
  selector: 'app-loadsheet-information',
  templateUrl: './loadsheet-information.component.html',
  styleUrls: ['./loadsheet-information.component.css']
})
export class LoadsheetInformationComponent implements OnInit {
  lid: any;
  cid: any;
  loadSheetNo: any;
  backDiv: any = false;
  client: any;
  transport_company: any;
  button_disable = false;
  apiUrl;
  branch;
  imagePath1: string;
  employeeList;
  loadSheetEmp;
  routePath;
  loadsheetUpdateForm: FormGroup;
  completed = false;
  updated_id;
  loadsheet_status;
  loadsheet_arr = [];
  routePath1: any;
  loadsheetData: any;
  orderList: any;
  clientData: any;
  orderNumber: any;
  editRowId: any;

  spinLoader = {
    pageLoaded: false,
    delete: []
  };

  constructor(private route: ActivatedRoute, private router: Router, private _services: ServicesService, private formBuilder: FormBuilder) {
    this.route.queryParams.subscribe(params => {
      this.lid = params['lid'];
      this.cid = params['cid'];
    });
  }
  ngOnInit() {

    let degrees = 0;
    $(document).on('click', '#btnRotateRight', function () {
      degrees += 90;
      $('#rotateImage').css({
        '-webkit-transform': 'rotate(' + degrees + 'deg)',
        '-moz-transform': 'rotate(' + degrees + 'deg)',
        '-ms-transform': 'rotate(' + degrees + 'deg)',
        'transform': 'rotate(' + degrees + 'deg)'
      });
    });

    this.apiUrl = environment.apiUrl;
    this._services.checkToken('status');
    this.Show();

    this.loadsheetUpdateForm = this.formBuilder.group({
      employee: ['', Validators.required],
      transport_company: ['', Validators.required],
      client: ['', Validators.required],
      branch: ['', Validators.required],
      load_date: ['', Validators.required],
      id: ['']

    });

    if (this.cid != undefined) {
      this.backDiv = true;
    } else {
      this.backDiv = false;
    }
    if (this.lid != '') {
      this.showLoadsheetInfo(this.lid, this.cid);
    }
  }


  /*------------------------------Table with Sorting Starts Here------------------------*/

  updateLoadsheetEmp() {
    // //console.log(this.loadsheetUpdateForm.status==='INVALID');
    if (this.loadsheetUpdateForm.status === 'INVALID') {
      swal({
        title: 'warning',
        text: 'Please fill the required  field',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: 'rgb(17, 205, 239)',
        cancelButtonColor: 'rgb(245, 54, 92)',
        confirmButtonText: 'Yes'
      });

      return;
    }

    // this.button_disable = true;
    this.routePath1 = 'update-loadsheet-info';
    const token = this._services.getToken();
    this._services.postRequest(this.loadsheetUpdateForm.value, this.routePath1, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        swal({
          title: 'Loadsheet',
          text: 'Loadsheet Updated Successfully',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        });
        // this.employeeList = data.result;

      }
      this.button_disable = false;
    });
  }

 

  updateLoadsheetEle(value) {

    if (this.loadsheet_arr.indexOf(value) < 0) {

      this.loadsheet_arr.push(value);
    } else {
      this.loadsheet_arr = this.loadsheet_arr.filter((ele: any) => {
        return value.value.component_id !== ele.value.component_id;
      });
      this.loadsheet_arr.push(value);
    }


  }

  updateLoadsheet() {
    if (this.loadsheetUpdateForm.status === 'INVALID') {
      swal({
        title: 'warning',
        text: 'Please fill the required  field',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: 'rgb(17, 205, 239)',
        cancelButtonColor: 'rgb(245, 54, 92)',
        confirmButtonText: 'Yes'
      });

      return;
    }

    this.routePath1 = 'update-loadsheet-info';
    const token = this._services.getToken();
    this._services.postRequest(this.loadsheetUpdateForm.value, this.routePath1, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        const routeData = 'Update_loadsheet';
        const data = {
          loadsheet_id: this.updated_id,
          arr: this.loadsheet_arr
        };
    
        this._services.postRequest(data, routeData, token).subscribe((response) => {
          swal({
            title: 'Success',
            text: 'The loadsheet has been updated successfully',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes"
          });
        },
        error => {
          swal({
            title: 'Error',
            text: 'The loadsheet could not be updated: ' + error.error.message,
            type: 'error',
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes"
          });
        }); 
      }
    });
  }


  Show() {
    this.routePath = 'get-employee-names';
    const token = this._services.getToken();
    const data = {

    };
    this._services.postRequest(data, this.routePath, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.employeeList = data.result;
      }
    }
    );

  }
  showLoadsheetInfo(id, cid) {
    this.spinLoader['pageLoaded'] = true;
    this.routePath = 'get-loadsheet-info';
    const token = this._services.getToken();
    const data = {
      loadsheet_id: id,
      client_id: cid,
    };

    this._services.postRequest(data, this.routePath, token).subscribe((data: any) => {
      this.spinLoader['pageLoaded'] = false;
      this.branch = data.result.branches;
      if (this._services.checkToken('status')) {
        for (const element in data.result.client) {
          this.clientData = data.result.client[element];
        }
        for (const element in data.result.loadsheet) {
          this.loadsheetData = data.result.loadsheet[element];
        }
        this.loadsheetData.image_1 = environment.imageUrl + this.loadsheetData.image_1;
        this.loadsheetData.image_2 = environment.imageUrl + this.loadsheetData.image_2;
        this.loadsheetData.image_3 = environment.imageUrl + this.loadsheetData.image_3;
        this.loadsheetData.emp_sign = environment.imageUrl + this.loadsheetData.emp_sign;
        this.loadsheetData.driver_sign = environment.imageUrl + this.loadsheetData.driver_sign;
        this.loadSheetNo = this.loadsheetData.loadsheet_no;
        this.loadSheetEmp = this.loadsheetData.user_id;
        this.loadsheet_status = data.result.loadsheet[0].loadsheet_status;

        this.updated_id = data.result.loadsheet[0].loadsheet_id;

        // this.transport_company=
        // //console.log(this.loadSheetEmp);
        this.orderList = [];
        this.orderList = data.result.orders;
        this.orderNumber = data.result.ordernumbers;
        if ((this.loadsheetData.driver_name == null || this.loadsheetData.driver_name == '')
          && (this.loadsheetData.emp_name == null || this.loadsheetData.emp_name == '')) {
          this.completed = true;
        }


        this.loadsheetUpdateForm.patchValue({ employee: this.loadSheetEmp });
        this.loadsheetUpdateForm.patchValue({ id: this.lid });
        this.loadsheetUpdateForm.patchValue({ transport_company: this.loadsheetData.transport_company });
        this.loadsheetUpdateForm.patchValue({ client: this.clientData.client_name });
        this.loadsheetUpdateForm.patchValue({ load_date: this.loadsheetData.schedule_date });
        this.loadsheetUpdateForm.patchValue({ branch: this.loadsheetData.branch_id });

      }
    });
  }
  imageModalShow(image) {
    const img_name = image;
    // alert(img_name);
    swal({
      title: '<p>Loadsheet</p> <button type="button"  id="btnRotateRight" class="rotate_button btnRotate"><span aria-hidden="true"><i class="fa fa-repeat" aria-hidden="true"></i></span></button>',
      html: '<img id="rotateImage" src="' + img_name + '" class="img-responsive">',
      // type: 'success',
      showCancelButton: false,
      showConfirmButton: false
      // confirmButtonColor: 'rgb(17, 205, 239)',
      // cancelButtonColor: 'rgb(245, 54, 92)',
      // confirmButtonText: 'Yes'
    });
  }

  toggle(id) {
    if (this.loadsheet_status !== 'completed') {
      this.editRowId = id;
    }
  }

  public removeEditingTemplate(event: KeyboardEvent): void {
    if (event && event.key) {
      switch (event.key) {
        case "Enter":
        case "Esc":
        case "Escape":
          this.editRowId = null; break;
      }
    }

    if (!event) {
      this.editRowId = null;
    }
  }
}
